import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowGoBack = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 13,
	height: 13,
	viewBox: "0 0 13 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2.61875 12.168V10.7992H8.20625C9.05625 10.7992 9.7875 10.518 10.4 9.95547C11.0125 9.39297 11.3187 8.69297 11.3187 7.85547C11.3187 7.01797 11.0125 6.31797 10.4 5.75547C9.7875 5.19297 9.05625 4.91172 8.20625 4.91172H2.9L4.94375 6.95547L3.9875 7.89297L0.3125 4.21797L3.9875 0.542969L4.94375 1.49922L2.9 3.54297H8.1875C9.4125 3.54297 10.4688 3.95859 11.3563 4.78984C12.2438 5.62109 12.6875 6.64297 12.6875 7.85547C12.6875 9.06797 12.2438 10.0898 11.3563 10.9211C10.4688 11.7523 9.4125 12.168 8.1875 12.168H2.61875Z",
		fill: "#3C59F6"
	})
});
export default SvgArrowGoBack;
